import { CircularProgress } from '@mui/material'
import AppTable from 'components/AppTable/AppTable'
import { toFullDateName } from 'helpers/dateHelper'
import { useRemoteResource } from 'hooks/useRemoteResource'
import { Link } from 'react-router-dom'
import { toCurrencyFormat } from 'helpers/utils'
import _ from 'lodash'
import { BookingStatusLabel } from 'data/bookingStatus'
import subOrdersService from 'services/admin/sub-orders.service'
import { OrderStatus } from 'components/OrderStatus'

export const UnpaidClients = () => {
    const columnConfig = [
        {
            label: '#',
            render: (v, index) => `${index + 1}`
        },
        {
            key: 'id',
            label: 'Номер Заказа',
            render: (i) => <Link className='color-blue' to={`/admin/sub-orders/view/${i.id}`}>{i.id}</Link>
        },
        {
            key: 'customer',
            label: 'Клиент',
            render: (i) => `${i.customer?.lastName} ${i.customer?.firstName}`
        },     
        {
            key: 'status',
            label: 'Статус заказа',
            render: (i) => <OrderStatus status={i.status} subStatus={i.subStatus}></OrderStatus>
        },
        {
            key: 'totalAmount',
            label: 'Общая сумма заказа',
            render: (i) => toCurrencyFormat(i.totalAmount, i.currency)
        },
    ]

    const [unpaidClients, loadData, loading, error] = useRemoteResource(() => subOrdersService.unpaidClients())

    console.log(`unpaidClients:`, unpaidClients);


    return loading ? <div className="text-center"><CircularProgress></CircularProgress></div> :
        <div>
            <h3 className='m-b-16'>Графа должников</h3>
            <AppTable data={unpaidClients} columnConfig={columnConfig}></AppTable>
        </div>
}
